import styled from 'styled-components';
import { Progress } from 'antd';
import { AA_LINK_ON_LIGHT } from '~/modules/Helper/contrast.helper';

const corProgresso = ({ theme }) => theme?.corTema || AA_LINK_ON_LIGHT;

export const TabelaAnexos = styled.div`
  .anexo-baixando > td {
    background: ${({ theme }) =>
      `${theme?.corTema || AA_LINK_ON_LIGHT}14`} !important;
  }

  @media (max-width: 576px) {
    .ant-table {
      min-width: 0;
    }
  }
`;

export const AnexoCelula = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  min-width: 0;
`;

export const AnexoProgresso = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  max-width: 420px;
`;

export const AnexoStatus = styled.span`
  font-size: 12px;
  line-height: 1.35;
  font-weight: 600;
  color: ${corProgresso};
`;

export const BarraProgresso = styled(Progress)`
  && {
    margin: 0;
    line-height: 1;
  }
`;

export const BarraIndeterminada = styled.div`
  position: relative;
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
  background: ${({ theme }) => `${theme?.corTema || AA_LINK_ON_LIGHT}22`};

  &::after {
    content: '';
    position: absolute;
    top: 0;
    height: 100%;
    width: 38%;
    border-radius: 999px;
    background: ${corProgresso};
    animation: anexo-download-slide 1.2s ease-in-out infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
      width: 100%;
      opacity: 0.55;
    }
  }

  @keyframes anexo-download-slide {
    0% {
      left: -38%;
    }
    100% {
      left: 100%;
    }
  }
`;
